import React from 'react';
import { Rendered, fill } from './shape';

/** A template as the lead sees it — one bubble, house tokens, no phone
 *  chrome (a real chat screen is not simulated: CLAUDE.md §3.22). */

const Media: React.FC<{ url: string; video: boolean; className: string }> = ({ url, video, className }) =>
  video
    ? <video src={`${url}#t=0.1`} muted playsInline preload="metadata" className={className} />
    : <img src={url} alt="" className={className} />;

const btnCls = 'block text-center text-[#2c6479] font-semibold border-t border-charcoal/10 mt-1.5 pt-1.5';

const WhatsAppBubble: React.FC<{ r: Rendered; wide?: boolean }> = ({ r, wide }) => {
  const body = fill(r.body, r.bodyVariables);
  const cards = r.templateType === 'CAROUSEL' ? r.carouselCards : [];
  return (
    <div className={`bg-[#e7f3e2] rounded-lg px-3 py-2.5 text-[12.5px] ${wide ? '' : 'max-w-[300px]'}`}>
      {cards.length > 0 ? (
        <>
          <div className="whitespace-pre-wrap break-words">{body || <i className="text-graphite">message text</i>}</div>
          <div className="flex gap-2 overflow-x-auto pb-1.5 mt-2" style={{ scrollbarWidth: 'thin' }}>
            {cards.map((c, i) => (
              <div key={i} className="flex-none w-[150px] bg-warm-white rounded-lg p-1.5 text-[11.5px]">
                <div className="h-[110px] rounded-md overflow-hidden bg-[#2b3a2e] mb-1.5">
                  {c.header_media_url && <Media url={c.header_media_url} video={c.header_format === 'VIDEO'} className="w-full h-full object-cover" />}
                </div>
                {c.title && <b className="block mb-0.5">{c.title}</b>}
                <span className="text-charcoal/80">{fill(c.body, c.body_variables || []).slice(0, 90)}</span>
                {c.buttons?.[0] && <span className={`${btnCls} text-[11px]`}>{c.buttons[0].text}</span>}
              </div>
            ))}
          </div>
        </>
      ) : (
        <>
          {r.headerMediaUrl && (
            <div className="h-[130px] rounded-md overflow-hidden bg-[#2b3a2e] mb-2 relative">
              <Media url={r.headerMediaUrl} video={r.templateType === 'VIDEO'} className="w-full h-full object-cover" />
              {r.templateType === 'VIDEO' && <span className="absolute inset-0 grid place-items-center text-warm-white/90 text-[26px]">▶</span>}
            </div>
          )}
          {!r.headerMediaUrl && ['IMAGE', 'VIDEO', 'DOCUMENT'].includes(r.templateType) && (
            <div className="h-[70px] rounded-md bg-gradient-to-br from-[#5f8a63] to-[#2f5236] mb-2 grid place-items-center text-warm-white/80 text-[11px]">{r.templateType.toLowerCase()} header</div>
          )}
          {r.headerText && <b className="block mb-1">{fill(r.headerText, r.bodyVariables)}</b>}
          <div className="whitespace-pre-wrap break-words">{body || <i className="text-graphite">message text</i>}</div>
          {r.footer && <div className="text-graphite text-[11px] mt-1.5">{r.footer}</div>}
          {r.buttons.map((b, i) => <span key={i} className={btnCls}>{b.type === 'PHONE_NUMBER' ? '📞 ' : ''}{b.text || 'button'}</span>)}
        </>
      )}
    </div>
  );
};

export default WhatsAppBubble;
